<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.5 2.90539V9.4999H9.5V3.46941H0.5V1.3999H7.53516V3.43321" stroke="var(--icon-color)" />
    <path
        d="M9.3125 5.49976H7.5C6.94772 5.49976 6.5 5.94747 6.5 6.49976V6.49976C6.5 7.05204 6.94772 7.49976 7.5 7.49976H9.3125"
        stroke="vat(--icon-color)" />
</svg>
